const agentRoles = [
  "agent",
  "manager",
  "rental_portfolio_manager",
  "small_landlord"
];

const hasUserAgentRole = userRole =>
  agentRoles.some(role => userRole?.includes(role));

export default hasUserAgentRole;
